<template>
    <div id="app">
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <router-view/>

        <BToast id="single-toast" :variant="toastInfo.variant"
                :auto-hide-delay="toastInfo.hide"
                solid
                toaster="b-toaster-bottom-center"
        >
            <template #toast-title>
                {{ toastInfo.title }}
            </template>
            {{ toastInfo.content }}
        </BToast>

        <b-toaster name="b-toaster-bottom-center" class="p-3"></b-toaster>
        <portal-target name="global-dropdown" multiple slim></portal-target>
    </div>
</template>

<script>

export default {
    data() {
        return {
            toastInfo: {
                variant: 'info',
                hide: 2000,
                title: '',
                content: ''
            }
        };
    },
    methods: {
        makeToast(title, contents, append = false, hide = 2000) {
            const toastContent = contents?.tag != null ? contents : `${contents}`;

            this.$bvToast.toast(toastContent, {
                title: title,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: append,
                // noAutoHide: true,
                autoHideDelay: hide,
                variant: 'info'
            });
        },
        makeToastFail(title, contents, append = false, hide = 2000) {
            const toastContent = contents?.tag != null ? contents : `${contents}`;

            this.$bvToast.toast(toastContent, {
                title: title,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: append,
                // noAutoHide: true,
                autoHideDelay: hide,
                variant: 'danger'
            });
        },
        makeToastWarning(title, contents, append = false, hide = 2000) {
            const toastContent = contents?.tag != null ? contents : `${contents}`;

            this.$bvToast.toast(toastContent, {
                title: title,
                toaster: 'b-toaster-bottom-center',
                solid: true,
                appendToast: append,
                autoHideDelay: hide,
                variant: 'warning'
            });
        },
        openSingleToast(info) {
            this.toastInfo.variant = info.variant || 'info';
            this.toastInfo.hide = info.hide || 2000;
            this.toastInfo.title = info.title || '';
            this.toastInfo.content = info.content || '';

            this.$bvToast.show('single-toast');
        }
    },
    mounted() {
        window.EventBus.$on('toast-success', this.makeToast);
        window.EventBus.$on('toast-failure', this.makeToastFail);
        window.EventBus.$on('toast-warning', this.makeToastWarning);

        this.$EventBus.$on('toast-success', this.makeToast);
        this.$EventBus.$on('toast-failure', this.makeToastFail);
        this.$EventBus.$on('toast-warning', this.makeToastWarning);
        this.$EventBus.$on('single-toast-on', this.openSingleToast);
    }

};
</script>

<style>

</style>
